import store from "../store";
import { IConfiguration } from "../domain/configuration";
import { LoggerFactory } from "./logger";

export class UrlSchemeClient {
  request(url: string): void {
    // PDFロードが中断されてしまう現象への対策のため、iframe経由でUrlSchemeを起動している
    // Vueの管理外のiframe要素にURLをセットすることで、仮想DOMと実DOMのずれを回避することを意図している
    const div = document.getElementById("url-scheme-iframe") as HTMLDivElement;
    if (!!div) {
      LoggerFactory.getLogger().debug("[iframe.src] " + url);
      const iframe = document.createElement("iframe");
      iframe.style.cssText = "width: 0px; height: 0px; border-width: 0px;";
      div.appendChild(iframe);
      iframe.src = url;
      setTimeout(() => {  // loadやDOMContentLoaded等のイベントを使用したかったが、chromeで発行してくれなかった。(UrlSchemeだから？)
        div.removeChild(iframe);
      }, 2000); // 0msの場合chromeで起動失敗する場合があるため暫定2s
    } else {
      this.suspendUnloadEvent();
      LoggerFactory.getLogger().debug("[location.href] " + url);
      location.href = url;
    }
  }

  /**
   * onbeforeunlod設定中に呼ばれてもいいように一旦handlerを退避する
   */
  private suspendUnloadEvent() {
    const handler = window.onbeforeunload;
    if (!handler) { return; }

    const config = store.getters.configuration as IConfiguration;
    window.onbeforeunload = function() {
      // 直接再設定するとIEの場合そのまま再設定されたハンドラも呼ばれてしまう.(chromeは問題ない.)
      // やむを得ないので設定で指定した時間だけ待つ.(イベントループに戻る事で続けて呼ばれる事はなくなる...と思われる.)
      setTimeout(() => {
        window.onbeforeunload = handler;
      }, config.system.urlScheme.beforeUnloadEventSetInterval);
    };
  }
}
